'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
export const UPLOAD_PARSER_CACHE_SETTINGS_KEY = 'deal-upload-parser-cache-settings';
export type UploadParserCacheSettings = {
  skipParserCacheRead: boolean;
  skipParserCacheWrite: boolean;
};
const DEFAULT_SETTINGS: UploadParserCacheSettings = {
  skipParserCacheRead: false,
  skipParserCacheWrite: false
};
function parseStoredSettings(raw: string | null): UploadParserCacheSettings {
  if (!raw) {
    return DEFAULT_SETTINGS;
  }
  try {
    const parsed = JSON.parse(raw) as Partial<UploadParserCacheSettings>;
    return {
      skipParserCacheRead: parsed.skipParserCacheRead === true,
      skipParserCacheWrite: parsed.skipParserCacheWrite === true
    };
  } catch {
    return DEFAULT_SETTINGS;
  }
}
export function readUploadParserCacheSettings(): UploadParserCacheSettings {
  if (typeof window === 'undefined') {
    return DEFAULT_SETTINGS;
  }
  return parseStoredSettings(sessionStorage.getItem(UPLOAD_PARSER_CACHE_SETTINGS_KEY));
}
function writeUploadParserCacheSettings(settings: UploadParserCacheSettings): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(UPLOAD_PARSER_CACHE_SETTINGS_KEY, JSON.stringify(settings));
}
export function useUploadParserCacheSettings() {
  const $ = _c(7);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setSettings(readUploadParserCacheSettings());
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = patch => {
      setSettings(current => {
        const next = {
          ...current,
          ...patch
        };
        writeUploadParserCacheSettings(next);
        return next;
      });
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateSettings = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = value => {
      updateSettings({
        skipParserCacheRead: value
      });
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const setSkipParserCacheRead = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = value_0 => {
      updateSettings({
        skipParserCacheWrite: value_0
      });
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const setSkipParserCacheWrite = t4;
  let t5;
  if ($[5] !== settings) {
    t5 = {
      settings,
      setSkipParserCacheRead,
      setSkipParserCacheWrite
    };
    $[5] = settings;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}